<script>
	import OffsetThresholdWrapperGBLE from './OffsetThresholdWrapperGBLE.svelte';

	export let device;
</script>

<OffsetThresholdWrapperGBLE {device} setting="offset" type="humidity" min={-30} max={30} />
